function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Accordion, Avatar, createForm, Dialog, Button, Flex, Heading, HelpText, MenuButton, Notice, Select, Text, Textarea, useId, useToasts } from '@applyboard/crystal-ui';
import { CheckMarkOutlineIcon, CloseOutlineIcon, DocumentIcon, MoreVertOutlineIcon, WarningOutlineIcon } from '@applyboard/ui-icons';
import { DynamicFormPreview } from "../../../../components/DynamicForm";
import { LegacyRemoveFileDialog } from "../LegacyRemoveFileDialog";
import { useApplication, useApplicationPagePermissions, useLegacyApplicationRequirements, useDeleteApplicationRequirementAttachment, useUpdateLegacyApplicationRequirement } from "../../data";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export function HybridRequirementPreviewMode(_ref) {
  var requirementId = _ref.requirementId,
    _onSuccess = _ref.onSuccess;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMenuOpen = _useState2[0],
    setIsMenuOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    fileToDelete = _useState4[0],
    setFileToDelete = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDisapprovalDialogOpen = _useState6[0],
    setIsDisapprovalDialogOpen = _useState6[1];
  var _useLegacyApplication = useLegacyApplicationRequirements(),
    applicationRequirements = _useLegacyApplication.applicationRequirements;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationPagePe = useApplicationPagePermissions(),
    permissions = _useApplicationPagePe.permissions;
  var requirement = applicationRequirements.find(function (requirement) {
    return requirement.id === requirementId;
  });
  var _useUpdateLegacyAppli = useUpdateLegacyApplicationRequirement(),
    updateApplicationRequirement = _useUpdateLegacyAppli.updateApplicationRequirement,
    isUpdatingApplicationRequirement = _useUpdateLegacyAppli.isUpdatingApplicationRequirement;
  var _useDeleteApplication = useDeleteApplicationRequirementAttachment(),
    deleteRequirementAttachments = _useDeleteApplication.deleteRequirementAttachments,
    isDeletingRequirementAttachments = _useDeleteApplication.isDeletingRequirementAttachments;
  var toasts = useToasts();
  if (!requirement) {
    return null;
  }
  var completeRequirement = function completeRequirement() {
    updateApplicationRequirement({
      id: requirement.id,
      status: 'status_completed'
    }, {
      onSuccess: function onSuccess(updatedAggregatedData) {
        toasts.positive('Requirement successfully completed!');
        var updatedRequirement = updatedAggregatedData.response.included.find(function (item) {
          return item.type === 'application_hybrid_requirements' && item.id === requirement.id.toString();
        });
        if (updatedRequirement) {
          _onSuccess(_objectSpread({
            id: updatedRequirement.id,
            type: updatedRequirement.type
          }, updatedRequirement.attributes));
        }
      },
      onError: function onError(error) {
        if (error instanceof Error) {
          toasts.negative(error);
        }
      }
    });
  };
  if (requirement.status === 'status_missing') {
    return _jsx(Flex.Item, {
      grow: 1,
      children: _jsxs(Flex, {
        justify: "center",
        pt: 24,
        px: 6,
        grow: 1,
        gap: 2,
        align: "center",
        children: [_jsx(DocumentIcon, {
          intent: "secondary",
          variant: "fill"
        }), _jsx(Text, {
          children: "No response for this requirement has been submitted"
        })]
      })
    });
  }
  return _jsxs(_Fragment, {
    children: [_jsxs(Flex, {
      grow: 1,
      direction: "column",
      px: 6,
      py: 3,
      children: [_jsxs(Flex, {
        direction: "row",
        justify: "between",
        align: "center",
        gap: 4,
        children: [_jsxs(Flex, {
          gap: 4,
          align: "center",
          children: [_jsx(Flex.Item, {
            children: _jsx(RequirementStatusIndicator, {
              requirementStatus: requirement.status
            })
          }), _jsx(Heading, {
            level: 3,
            variant: "titleL",
            children: requirement.title
          })]
        }), _jsx(DisapproveRequirementDialog, {
          requirement: requirement,
          onSuccess: _onSuccess,
          isOpen: isDisapprovalDialogOpen,
          onOpenChange: setIsDisapprovalDialogOpen
        }), requirement.status === 'status_reviewing' ? _jsxs(Flex, {
          gap: 2,
          children: [_jsx(Button, {
            emphasis: "outlined",
            intent: "primary",
            leadIcon: CloseOutlineIcon,
            onClick: function onClick() {
              return setIsDisapprovalDialogOpen(true);
            },
            children: "Disapprove"
          }), _jsx(Button, {
            intent: "primary",
            loading: isUpdatingApplicationRequirement,
            leadIcon: CheckMarkOutlineIcon,
            onClick: completeRequirement,
            children: "Complete"
          })]
        }) : _jsxs(MenuButton, {
          onOpenChange: setIsMenuOpen,
          open: isMenuOpen,
          children: [_jsx(MenuButton.Trigger, {
            children: _jsx(Button, {
              leadIcon: MoreVertOutlineIcon,
              emphasis: "outlined",
              intent: "primary",
              "aria-label": "Change requirement status"
            })
          }), _jsx(MenuButton.Button, {
            id: "changeRequirementStatusMenu",
            icon: requirement.status === 'status_completed' ? CloseOutlineIcon : CheckMarkOutlineIcon,
            onClick: function onClick() {
              if (requirement.status === 'status_completed') {
                setIsDisapprovalDialogOpen(true);
              } else {
                completeRequirement();
              }
              setIsMenuOpen(false);
            },
            children: requirement.status === 'status_completed' ? 'Change to Not Approved' : 'Change to Complete'
          })]
        })]
      }), _jsxs(Flex, {
        direction: "column",
        gap: 6,
        pt: 6,
        children: [_jsx(Notice, {
          intent: "primary",
          children: "This new requirement type offers a slightly different way to preview requirement responses and documents. Use the 'Complete' or 'Disapprove' button to make a decision on the requirement data displayed below. After the decision is made, a new '3 dot' button shows up. It can be used to update a requirement status."
        }), _jsx(DynamicFormPreview, {
          formDefinition: requirement.formDefinition,
          formData: requirement.formData,
          files: requirement.files,
          filePreviewType: "preview",
          AdditionalFileInformation: FileValidationResults,
          onDeleteFileClick: permissions !== null && permissions !== void 0 && permissions.destroy_requirement_attachment_for_pii ? function (fileId) {
            var fileToDelete = requirement.files.find(function (file) {
              return file.id === fileId;
            });
            if (fileToDelete) {
              setFileToDelete(fileToDelete);
            }
          } : undefined
        })]
      })]
    }), _jsx(LegacyRemoveFileDialog, {
      applicationId: application.id,
      requirementId: requirement.id,
      isOpen: !!fileToDelete,
      isRemovingFile: isDeletingRequirementAttachments,
      onOpenChange: function onOpenChange(open) {
        if (!open) {
          setFileToDelete(undefined);
        }
      },
      attachmentId: fileToDelete === null || fileToDelete === void 0 ? void 0 : fileToDelete.id,
      fileName: fileToDelete === null || fileToDelete === void 0 ? void 0 : fileToDelete.name,
      onConfirmNonPiiDelete: function onConfirmNonPiiDelete() {
        if (fileToDelete) {
          deleteRequirementAttachments({
            attachmentId: fileToDelete === null || fileToDelete === void 0 ? void 0 : fileToDelete.id,
            requirementId: requirementId
          }, {
            onSuccess: function onSuccess() {
              toasts.positive('File successfully removed.');
              setFileToDelete(undefined);
            },
            onError: function onError(error) {
              if (error instanceof Error) {
                toasts.negative(error);
              } else {
                toasts.negative(new Error('Something went wrong removing the file.'));
              }
            }
          });
        }
      },
      onSuccess: function onSuccess() {
        toasts.positive('File successfully removed.');
        setFileToDelete(undefined);
      },
      requirementType: "hybrid"
    })]
  });
}
var _createForm = createForm(),
  Field = _createForm.Field,
  Form = _createForm.Form,
  useFieldValues = _createForm.useFieldValues;
function DisapproveRequirementDialog(_ref2) {
  var requirement = _ref2.requirement,
    _onSuccess2 = _ref2.onSuccess,
    isOpen = _ref2.isOpen,
    onOpenChange = _ref2.onOpenChange;
  var formId = useId();
  var toasts = useToasts();
  var _useUpdateLegacyAppli2 = useUpdateLegacyApplicationRequirement(),
    updateApplicationRequirement = _useUpdateLegacyAppli2.updateApplicationRequirement,
    isUpdatingApplicationRequirement = _useUpdateLegacyAppli2.isUpdatingApplicationRequirement;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: onOpenChange,
    children: [_jsx(Dialog.Heading, {
      disabled: isUpdatingApplicationRequirement,
      children: "Disapprove the Requirement?"
    }), _jsx(Dialog.Content, {
      children: _jsx(Form, {
        defaultValues: {
          disapprovalReason: '',
          additionalInformation: ''
        },
        id: formId,
        onSubmit: function onSubmit(formValues) {
          var _formValues$additiona;
          updateApplicationRequirement({
            id: requirement.id,
            status: 'status_not_approved',
            decisionReasons: [{
              title: formValues.disapprovalReason,
              notes: (_formValues$additiona = formValues.additionalInformation) !== null && _formValues$additiona !== void 0 && _formValues$additiona.length ? formValues.additionalInformation : undefined
            }]
          }, {
            onSuccess: function onSuccess(updatedAggregatedData) {
              toasts.positive('Requirement successfully disapproved!');
              var updatedRequirement = updatedAggregatedData.response.included.find(function (item) {
                return item.type === 'application_hybrid_requirements' && item.id === requirement.id.toString();
              });
              if (updatedRequirement) {
                _onSuccess2(_objectSpread({
                  id: updatedRequirement.id,
                  type: updatedRequirement.type
                }, updatedRequirement.attributes));
              }
              onOpenChange(false);
            },
            onError: function onError(error) {
              if (error instanceof Error) {
                toasts.negative(error);
              }
            }
          });
        },
        children: _jsxs(Flex, {
          direction: "column",
          gap: 3,
          children: [_jsxs(Text, {
            intent: "secondary",
            variant: "bodyS",
            children: ["You're about to disaprove the requirement \"", requirement.title, "\". Please select a disapproval reason in the field below."]
          }), _jsx(Field, {
            as: Select,
            name: "disapprovalReason",
            label: "Disapproval reason",
            required: "Please select a rejection reason.",
            placeholder: "Select a reason from the list",
            appearance: "styled",
            children: requirement.rejectionOptions.map(function (option) {
              return _jsx(Select.Option, {
                label: option.description,
                value: option.code
              }, option.code);
            })
          }), _jsx(AdditionalInformationTextarea, {
            disapprovalReasons: requirement.rejectionOptions
          }), _jsx(Text, {
            intent: "secondary",
            variant: "bodyS",
            children: "Please confirm that you want to disapprove the requirement. Once your confirmation is provided, you will not be able to modify the requirement."
          })]
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        disabled: isUpdatingApplicationRequirement,
        children: "Cancel"
      }), _jsx(Button, {
        emphasis: "outlined",
        intent: "primary",
        type: "submit",
        form: formId,
        loading: isUpdatingApplicationRequirement,
        children: "Disapprove requirement"
      })]
    })]
  });
}
function AdditionalInformationTextarea(_ref3) {
  var _disapprovalReasons$f;
  var disapprovalReasons = _ref3.disapprovalReasons;
  var _useFieldValues = useFieldValues(),
    disapprovalReason = _useFieldValues.disapprovalReason;
  if (!disapprovalReason) {
    return null;
  }
  return _jsxs(_Fragment, {
    children: [_jsxs(Text, {
      intent: "secondary",
      variant: "bodyS",
      children: ["Feel free to provide additional information on why you think \"", (_disapprovalReasons$f = disapprovalReasons.find(function (reason) {
        return reason.code === disapprovalReason;
      })) === null || _disapprovalReasons$f === void 0 ? void 0 : _disapprovalReasons$f.description, "\""]
    }), _jsx(Field, {
      as: Textarea,
      name: "additionalInformation",
      label: "Additional information",
      required: "Please provide additional information about the rejection."
    })]
  });
}
function RequirementStatusIndicator(_ref4) {
  var requirementStatus = _ref4.requirementStatus;
  if (requirementStatus === 'status_completed') {
    return _jsx(Avatar, {
      "aria-label": "Requirement status: Complete",
      emphasis: "highlighted",
      intent: "positive",
      "aria-hidden": false,
      icon: CheckMarkOutlineIcon
    });
  }
  if (requirementStatus === 'status_not_approved') {
    return _jsx(Avatar, {
      "aria-label": "Requirement status: Not approved",
      emphasis: "highlighted",
      intent: "negative",
      "aria-hidden": false,
      icon: CloseOutlineIcon
    });
  }
  return _jsx(Avatar, {
    "aria-label": "Requirement status: Reviewing",
    emphasis: "highlighted",
    intent: "warning",
    "aria-hidden": false,
    icon: WarningOutlineIcon
  });
}
function FileValidationResults(_ref5) {
  var file = _ref5.file;
  if (!file.validationResults.length) {
    return null;
  }
  var sortedResults = getsortedValidationResults(file.validationResults);
  return _jsx(Accordion, {
    allowMultipleOpen: true,
    children: sortedResults.map(function (result, index) {
      return _jsx(Accordion.Item, {
        id: "".concat(file.id, "-").concat(result.intent),
        title: "".concat(result.label, " (").concat(result.messages.length, ")"),
        children: _jsx(Flex, {
          direction: "column",
          gap: 4,
          children: result.messages.map(function (message, index) {
            return _jsx(HelpText, {
              intent: result.intent,
              showIcon: true,
              children: message
            }, index);
          })
        })
      }, index);
    })
  });
}
function getsortedValidationResults(validationResults) {
  var sortedResults = [{
    label: 'Errors',
    intent: 'negative'
  }, {
    label: 'Warnings',
    intent: 'warning'
  }, {
    label: 'Success',
    intent: 'positive'
  }];
  return sortedResults.map(function (sortedResult) {
    return _objectSpread(_objectSpread({}, sortedResult), {}, {
      messages: validationResults.filter(function (result) {
        return result.status === sortedResult.intent;
      }).map(function (result) {
        return result.message;
      })
    });
  }).filter(function (result) {
    return result.messages.length;
  });
}